import React, { useEffect, useState } from 'react'
import Scorer from '../ui/Scorer';
import { Button } from '../Buttons/Button';
import { showErrorToast } from '../ui/Toast';
import axios from '../../services/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateStageStatus } from '../../redux/applicationStageSlice';
import { useDispatch } from 'react-redux';
import { scoreRoundTwo } from '../../services/hr.service';

function StageRating({customSchema,candidateId,jobId,name,candidate,onSubmit,stageConfig,role}) {
    const [rating, setRating] = useState(stageConfig?.hasSplitScoring ? Object.fromEntries(Object.entries(stageConfig?.score)?.map(([key,value])=>[key,0])) : 0);
    const [feedback, setFeedback] = useState('');
  
    //Round2 
    const [score, setScore] = useState(0);

    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    useEffect(() => {
      if(stageConfig?.hasSplitScoring && customSchema){
        let newRating = {...rating}
        customSchema?.map(schema => {
          if(rating.hasOwnProperty(schema?.defaultKey)){
            delete newRating[schema?.defaultKey]
            newRating[schema.customKey] = 0
          } 
        })
        setRating(newRating)
      }
    },[stageConfig?.hasSplitScoring,customSchema])

    const scoreRoundTwoMutation = useMutation({
      mutationFn: scoreRoundTwo,
      onSuccess: (data) => {
          dispatch(updateStageStatus({
              stage: 'Round 2',
              status: 'Reviewed',
              data: data.updatedStageStatus
          }));
          queryClient.invalidateQueries(['candidate', candidateId, jobId]);
      },
      onError: (error) => {
          console.error("Error scoring Round 2:", error);
          // Handle error (e.g., show error message to user)
      }
  });

  const handleScoreSubmit = () => {
      scoreRoundTwoMutation.mutate({ candidateId, jobId, score, feedback });
  };

    const handleRatingChange = (category, value) => {
      setRating(prev => ({ ...prev, [category]: value }));
    };

    const handleSubmit = () => {
      if(stageConfig?.hasSplitScoring){
        if(Object.entries(rating).filter(([key,value]) => key !== "Budget" && value === 0)?.length > 0){
            showErrorToast("Oopss","Please rate the candidate")
            return
        }
      }else{
        if(rating < 1){
          showErrorToast("Oopss","Please rate the candidate")
          return
        }
      }
      if (!feedback.trim()) {
        showErrorToast("Oops", "Please enter feedback to proceed");
        return;
      }
      onSubmit(candidate._id, {
        jobId: candidate.currentApplication?.jobId ? candidate.currentApplication.jobId  : candidate.jobApplication.jobId ,
        stage: candidate.currentApplication?.currentStage ? candidate.currentApplication.currentStage : candidate.jobApplication.currentStage,
        ratings: rating,
        feedback,
      });
    };
    if(stageConfig?.name === "Round 2"){
      return (
        <>
            <div className='flex gap-4 mt-4'>
                <div className="flex flex-col w-full typography-body gap-4">
                    <span>Feedback:</span>

                    <textarea
                        className="w-full rounded-xl px-3 py-2 bg-background-70 hover-outline  outline-none focus:outline-teal-300 resize-none"
                        placeholder="Why this score ?"
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        rows={4}
                    />
                </div>
                <div className="flex flex-col  gap-4">
                    <span>Score:</span>
                    <Scorer value={score} onChange={setScore} />
                </div>

            </div>
            <div className='flex justify-end typography-body'>
                    <Button onClick={handleScoreSubmit} disabled={score === 0 || feedback === ''}>
                        Submit Score
                    </Button>
            </div>
        </>
      )
    }else{
      return (
        <div className='bg-background-70 flex flex-col typography-body gap-4 rounded-xl mt-4 p-4'>
          {stageConfig?.hasSplitScoring ? 
          <>
          <div className='grid grid-cols-2 w-full gap-4'>
            {Object.entries(rating).map(([category, value]) => {
              if(category !== "Budget")
              return (
              <div key={category} className='flex gap-4 items-center'>
                <span className=' w-[35%] '>{category}</span>
                <Scorer value={rating[category]} onChange={(v) => handleRatingChange(category, v)} />
      
              </div>
            )})}
            <div className='flex gap-4'>
              <input
                type="text"
                className='w-full bg-background-80  p-2 rounded'
                placeholder='Why this score?'
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <Button variant="icon" onClick={handleSubmit} disabled={!feedback.trim() || Object.entries(rating).some(([key, value]) => key !== "Budget" && value === 0)}>Submit</Button>
            </div>
          </div>
          </>
          :
          <>
<div className="flex items-center justify-between gap-4">
            <span className='flex-shrink-0 '>{name} Ratings</span>
            <div className='flex w-[70%] gap-4'>
              <Scorer value={rating} onChange={setRating} />
              <input
                type="text"
                className='w-full bg-background-80  p-2 rounded'
                placeholder='Why this score?'
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <Button variant="icon" onClick={handleSubmit} disabled={rating < 1 || !feedback.trim()}>Submit</Button>
            </div>
          </div>
          </>}
        </div>
      );
    }
}

export default StageRating
